import { memoizeFunction } from '@fluentui/react/lib/Utilities';
import { mergeStyleSets, mergeStyles } from '@fluentui/react/lib/Styling';
export var getStatusWrapperClassName = memoizeFunction(function (statusWrapperMinWidth) {
    return mergeStyles({
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: statusWrapperMinWidth,
        selectors: {
            '@media screen and (max-width: 450px)': {
                minWidth: 0,
            },
        },
    });
});
export var getDocumentTitleLabelStyles = memoizeFunction(function () {
    return mergeStyleSets({
        documentTitleSeparator: {
            padding: '0 2px',
        },
        status: {
            paddingLeft: 4,
            paddingRight: 4,
            textAlign: 'left',
        },
        statusWrapper: {
            selectors: {
                '@media screen and (max-width: 450px)': {
                    display: 'none',
                },
            },
        },
    });
});
export var getDocumentTitleToolTipStyles = memoizeFunction(function () {
    return { root: { display: 'inline-block' } };
});
//# sourceMappingURL=DocumentTitleStatusLabel.Styles.js.map